export const CROWDIN_DISTRIBUTION_HASH = import.meta.env.VITE_CROWDIN_DISTRIBUTION_HASH || '';

export const I18N_NAMESPACES = ['common', 'subscription', 'unsubscribe'] as const;
export type TI18nNamespace = (typeof I18N_NAMESPACES)[number];

export const I18N_SUPPORTED_LANGUAGES = ['en', 'de', 'fr', 'es-ES', 'it', 'el'] as const;
export type TI18nLanguage = (typeof I18N_SUPPORTED_LANGUAGES)[number];

export const I18N_FALLBACK_LANGUAGE: TI18nLanguage = 'en';
export const I18N_DEFAULT_NAMESPACE: TI18nNamespace = 'common';

export const I18N_CACHE_TTL_MS = 10 * 60 * 1000; // 10 minutes in milliseconds
export const I18N_LOCALSTORAGE_PREFIX = 'i18n_cache_';

export const isOtaEnabled = (): boolean => Boolean(CROWDIN_DISTRIBUTION_HASH);
